module.exports = __webpack_public_path__ + "media/images/competencias-6364bfe87301d85fcae6fd13d5a398a8.png";